import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'numberTruncated',
	standalone: false,
})
export class NumberTruncatedPipe implements PipeTransform {
	transform(
		value: number | null | undefined,
		{
			prefix = '',
			suffix = '',
			millionsDecimalPlaces = 2,
			thousandsDecimalPlaces = 1,
			tensDecimalPlaces = 2,
		}: { prefix?: string; suffix?: string; millionsDecimalPlaces?: number; thousandsDecimalPlaces?: number; tensDecimalPlaces?: number } = {},
	): string {
		if (value === null || value === undefined || isNaN(value)) {
			return '--';
		}

		const absValue = Math.abs(value);
		const sign = value < 0 ? '-' : '';
		let result = '';

		if (absValue >= 1000000) {
			// keep 2 decimal place
			result = (Math.trunc((absValue / 1000000) * 10) / 10).toFixed(millionsDecimalPlaces) + 'M';
		} else if (absValue >= 1000) {
			// keep 1 decimal place
			result = (Math.trunc((absValue / 1000) * 10) / 10).toFixed(thousandsDecimalPlaces) + 'k';
		} else {
			// keep 2 decimal place
			result = (Math.trunc(absValue * 100) / 100).toFixed(tensDecimalPlaces);
		}

		return prefix + sign + result + suffix;
	}
}
